<template>
  <div>
    <div
      class="sky__mobile-bar"
    >
      <div v-if="isCheckout" class="flex px-4 justify-between items-center h-full">
        <a :href="$route.path === '/transaction' ? '/commande' : '/'" class="flex items-center" style="width: 86px">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#06132F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          <span class="text-xs text-sky_blue ml-1">Retour</span>
        </a>
        <a href="/" class="flex">
          <icon-logo style="width: 60px; height: 50px;" />
        </a>
        <div class="flex items-center justify-end text-xs text-sky_grey" style="width: 86px">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
          <span class="ml-1">Sécurisé</span>
        </div>
      </div>
      <div v-else class="flex pr-4 justify-between items-center">
        <div class="flex">
          <div
            v-wave
            class="cursor-pointer flex items-center px-4"
            @click.stop="$store.commit('ui/TOGGLE_MOBILE_MENU')"
          >
            <icon-nav-cross v-if="showMobileMenu" style="width: 36px;" />
            <icon-burger v-else style="width: 36px;" />
          </div>
          <nuxt-link to="/recherche">
            <icon-search style="width: 50px; height: 50px;" @click="$router.push('/recherche')" />
          </nuxt-link>
        </div>
        <a href="/" class="flex">
          <icon-logo style="width: 60px; height: 50px;" />
        </a>
        <div class="flex justify-end" style="width: 86px">
          <nuxt-link to="/mon-compte">
            <icon-account style="width: 36px;" class="mx-auto" />
          </nuxt-link>
          <my-cart-button />
        </div>
      </div>
    </div>
    <div v-if="configuration.general_offer && !isCheckout" class="sky__promotion-bar flex items-center justify-center text-xxs px-4" v-html="transformedBanner">
    </div>
    <div
      class="bg-white block lg:hidden"
      :style="{
        height: `${mobileBarHeight}px`
      }"
    />
  </div>
</template>

<script>
import { marked } from 'marked'
import MyCartButton from './menu/MyCartButton'
export default {
  components: {
    MyCartButton
  },
  props: {
    configuration: {
      type: Object,
      required: false
    }
  },
  computed: {
    isCheckout () {
      return this.$route.path === '/transaction' || this.$route.path === '/commande'
    },
    showMobileMenu () {
      return this.$store.state.ui.showMobileMenu
    },
    transformedBanner () {
      if (!this.configuration?.general_offer) {
        return null
      }
      return marked(this.configuration.general_offer)
    },
    mobileBarHeight () {
      return (this.transformedBanner && !this.isCheckout) ? 100 : 50
    }
  }
}
</script>

<style lang="scss" scoped>
  .sky__mobile-bar {
    @apply fixed z-50 bg-white left-0 right-0 border-b bg-white;
    height: 50px;
    top: 0px;
    @screen lg {
      @apply hidden;
    }
  }
  .sky__promotion-bar {
    @apply absolute z-10 bg-sky_blue text-white left-0 right-0 text-center;
    top: 50px;
    height: 50px;
    @screen lg {
      @apply hidden;
    }
  }
</style>
